"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UnstyledInput;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./unstyledInput.css");

function generateInputProps(props) {
  var inputProps = (0, _objectSpread3.default)({}, props);
  delete inputProps.showInputIcon;
  delete inputProps.inputRef;
  delete inputProps.hintType;
  delete inputProps.hintMessage;
  delete inputProps.className;
  delete inputProps.ref;
  return inputProps;
}

function UnstyledInput(props) {
  var isIcon = !(props.hintType === 'normal' || !props.showInputIcon || props.hintType !== 'normal' && !props.hintMessage);
  var className = "unstyled_input ".concat(props.className, " ").concat(isIcon ? 'unstyled_input_icon' : '');
  return _react.default.createElement("input", (0, _extends2.default)({}, generateInputProps(props), {
    className: className,
    ref: props.inputRef
  }));
}

UnstyledInput.propTypes = {
  className: _propTypes.default.string,
  hintType: _propTypes.default.string,
  showInputIcon: _propTypes.default.bool,
  hintMessage: _propTypes.default.string,
  inputRef: _propTypes.default.shape({
    current: _propTypes.default.instanceOf(Element)
  })
};